export const UPDATE_FEATURED_LIST = 'featured/UPDATE_FEATURED_LIST'
export const UPDATE_FIRST_INDEX = 'featured/UPDATE_FIRST_INDEX'

